(function () {
  'use strict';

  function isVoucherTitle(title) {
    var normalized = String(title || '').replace(/[-_]/g, ' ').replace(/[’']/g, '').replace(/\s+/g, ' ').toLowerCase();
    return /buon[oi] (?:d ?)?(?:sconto|acquisto)/.test(normalized);
  }

  function isVisible(product) {
    return Boolean(product && product.available !== false && !isVoucherTitle(product.title));
  }

  function catalogUrl(value, resetPage) {
    try {
      var url = new URL(value, window.location.href);
      if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return value;
      var key, required;
      if (/\/collections\/[^/]+(?:\/[^/]+)?\/?$/.test(url.pathname) && url.pathname.indexOf('/products/') === -1) {
        key = 'filter.v.availability'; required = '1';
      } else if (/\/search\/?$/.test(url.pathname)) {
        key = 'options[unavailable_products]'; required = 'hide';
      } else { return value; }
      var values = url.searchParams.getAll(key);
      if (values.length !== 1 || values[0] !== required) {
        url.searchParams.delete(key);
        url.searchParams.set(key, required);
        if (resetPage) url.searchParams.delete('page');
      }
      return url.href;
    } catch (ignore) { return value; }
  }

  window.ErredueCatalog = {isVisible: isVisible, isVoucherTitle: isVoucherTitle, url: catalogUrl};

  // Direct links, including advertisements, get Shopify's native availability filter.
  // Pagination then operates on the filtered collection, once Availability is enabled in admin.
  if (!document.documentElement.hasAttribute('data-er-design-mode')) {
    var destination = catalogUrl(window.location.href, true);
    if (destination !== window.location.href) window.location.replace(destination);
  }

  function updateLinks(scope) {
    scope.querySelectorAll('a[href]').forEach(function (link) {
      var value = link.getAttribute('href');
      if (!value || value.charAt(0) === '#') return;
      var destination = catalogUrl(value, true);
      if (destination !== value) link.setAttribute('href', destination);
    });
  }

  function init() {
    updateLinks(document);
    document.addEventListener('shopify:section:load', function (event) { updateLinks(event.target); });
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link || link.getAttribute('href').charAt(0) === '#') return;
      var destination = catalogUrl(link.getAttribute('href'), true);
      link.setAttribute('href', destination);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
